import { render, staticRenderFns } from "./customsClearanceCancelled.vue?vue&type=template&id=68c5c857&scoped=true&"
import script from "./customsClearanceCancelled.vue?vue&type=script&lang=js&"
export * from "./customsClearanceCancelled.vue?vue&type=script&lang=js&"
import style0 from "./customsClearanceCancelled.vue?vue&type=style&index=0&id=68c5c857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5c857",
  null
  
)

export default component.exports